import React from "react";

import { Stack } from "@chakra-ui/react";

import { getAnswerTypeFromQuestionType } from "../../utils/AnswerValueHelpers";

import AnswerAutoSave from "../answers/AnswerAutoSave";

import QuestionTimeTracking from "./QuestionTimeTracking";
import QuestionHiddenInputs from "./QuestionHiddenInputs";
import QuestionComment from "./QuestionComment";
import ProgressNotifier from "./ProgressNotifier";

import { QuestionProps } from "./types/QuestionProps";

type QuestionCommonInputsConfig = {
  hasComment: boolean;
  hasTimeTracked: boolean;
};

const QuestionCommonInputs: React.FC<
  QuestionProps & { config: QuestionCommonInputsConfig }
> = ({ config, ...questionProps }) => {
  return (
    <Stack spacing="5">
      <ProgressNotifier {...questionProps} />
      <QuestionHiddenInputs
        {...questionProps}
        type={getAnswerTypeFromQuestionType(questionProps.question.type)}
      />
      {config.hasTimeTracked && <QuestionTimeTracking {...questionProps} />}
      {config.hasComment && <QuestionComment {...questionProps} />}
      <AnswerAutoSave {...questionProps} />
    </Stack>
  );
};

export default QuestionCommonInputs;
